module.exports = __webpack_public_path__ + "static/media/icon-instagram.996b697c.svg";